function publicUrl(path) {
  return `${process.env.PUBLIC_URL}${path}`;
}

export default publicUrl;
